import { EnrollmentHistoryEntry } from '../types';

const byEffectiveDateDesc = (a: EnrollmentHistoryEntry, b: EnrollmentHistoryEntry) =>
    (b.effective_date ?? '').localeCompare(a.effective_date ?? '');

/**
 * Collapses the enrollment timeline into the member's current standing. The API
 * says "most recent first", but it's re-sorted here so the summary can't silently
 * read a stale entry if that ordering ever changes.
 */
export const summarizeEnrollment = (entries: EnrollmentHistoryEntry[]) => {
    const timeline = [...entries].sort(byEffectiveDateDesc);

    const latestByProgram = new Map<string, EnrollmentHistoryEntry>();
    timeline.forEach((entry) => {
        if (entry.program && !latestByProgram.has(entry.program)) {
            latestByProgram.set(entry.program, entry);
        }
    });

    const enrolledPrograms = [...latestByProgram.values()]
        .filter((entry) => entry.status?.toLowerCase() === 'enrolled')
        .map((entry) => entry.program as string);

    return { timeline, current: timeline[0] ?? null, enrolledPrograms };
};
